import { Stack, Image, Title } from '@mantine/core';
import OkrsImage from '@assets/creating-okrs.png';

function BannerOkrs() {
  return (
    <Stack align="center" justify="center" mt="20vh">
      <Title c="white" ta="center">
        Creating OKRs
      </Title>
      <Image w="40%" src={OkrsImage} />
    </Stack>
  );
}

export { BannerOkrs };
